<template>
  <div
    class="vs-col"
    :class="[`vs-xs-${vsXs}`, `vs-sm-${vsSm}`, `vs-lg-${vsLg}`]"
    :style="columnStyle"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "VsCol",
  props: {
    vsW: {
      type: [Number, String],
      default: 12,
    },
    vsXs: {
      type: [Number, String],
      default: "",
    },
    vsSm: {
      type: [Number, String],
      default: "",
    },
    vsLg: {
      type: [Number, String],
      default: "",
    },
    vsOffset: {
      type: [Number, String],
      default: 0,
    },
    vsType: {
      type: String,
      default: null,
    },
    vsJustify: {
      type: String,
      default: null,
    },
    vsAlign: {
      type: String,
      default: null,
    },
    vsOrder: {
      type: [String, Number],
      default: null,
    },
  },
  computed: {
    columnStyle() {
      return {
        order: this.vsOrder,
        justifyContent: this.vsJustify,
        display: this.vsType,
        alignItems: this.vsAlign,
        marginLeft: `${(Number(this.vsOffset) * 100) / 12}%`,
        width: `${(Number(this.vsW) * 100) / 12}%`,
      };
    },
  },
};
</script>
